import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import TextField from '@mui/material/TextField';
import AutoComplete from '@mui/material/Autocomplete';
import DatePicker from "react-datepicker";
import {Box, ThemeProvider } from '@mui/material';
import "react-datepicker/dist/react-datepicker.css";
import {baseUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

const EqpGrnEntry = (props) => {
  const [consData, setConsData] = useState([]);
  const [items, setItems] = useState([]);
  const [rows, setRows] = useState([{ id: '', hsn: '', product: '', pack: '', fqty: '', totqty: '', pprice: '', mrp: '', disc: '', sgst: '', cgst: '' }]);
  const [subtotal, setSubTotal] = useState(0);
const [selectedDate, setSelectedDate] = useState(new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000));
  const [selectedDate1, setSelectedDate1] = useState(new Date());
    const currentDate = new Date();
  const formattedDate = currentDate.toLocaleDateString('en-GB').replace(/\//g, '-');


  const [pharmData, setpharmData] = useState({
    supp: '',
    grn_no: '',
    product: '',
    pack: '',
    qty: '',
    fqty: '',
    totqty: '',
    mrp: '',
    pprice: '',
    disc: '',
    sgst: '',
    cgst: '',
    netamount: '',
    gstamount: '',
    grnamount: '',
    invamount: '',
    grn_date: '',
    inv_date: '',
    invoice: '',
    status: '',
    addedby: '',
    ip_add: '',
  });


  useEffect(() => {
    fetchPharmData();
    fetchConsData();
  }, []);

  const fetchPharmData = () => {
    axios.get(`${baseUrl}eqp-search/`)
      .then(response => setItems(response.data))
      .catch(error => console.log(error));
  };

  const fetchConsData = () => {
    axios.get(`${baseUrl}add-supplier/`)
      .then(response => setConsData(response.data))
      .catch(error => console.log(error));
  };

const handleDateChange = (date) => {
   if (date) {
    const dateString = date.toISOString().slice(0,10);
    const dateObj = new Date(dateString);
    dateObj.setHours(0, 0, 0, 0);
    setSelectedDate(dateObj);
   }
  };
  const handleDateChange1 = (date) => {
   if (date) {
    const dateString = date.toISOString().slice(0,10);
    const dateObj = new Date(dateString);
    dateObj.setHours(0, 0, 0, 0);
    setSelectedDate1(dateObj);
   }
  };

const handleConsChange = (event) => {
  const selectedValue = event.target.value;
  setpharmData(prevState => ({ ...prevState, supp: selectedValue }));
};
const handleKeyDown = (e, index) => {
      const newRows = [...rows];
      switch (e.keyCode) {
        // Handle Shift key
        case 16:
          e.preventDefault();
            if (index === rows.length - 1) {
              newRows.push({ hsn: '', product: '', pack: '', fqty: '', totqty: '', pprice: '', mrp: '', disc: '',
                    sgst: '', cgst: '', batch: '', expiry: '' });
            }
          break;
        // Handle arrow up key
        case 90:
          e.preventDefault();
            newRows.splice(index, 1);
          break;
        case 38:
          e.preventDefault();
          if (newRows[index].selectedItem === 0) {
            newRows[index].selectedItem = items.length - 1;
          } else {
            newRows[index].selectedItem--;
          }
          setRows(newRows);
          break;
        // Handle arrow down key
        case 40:
          e.preventDefault();
          if (newRows[index].selectedItem === items.length - 1) {
            newRows[index].selectedItem = 0;
          } else {
            newRows[index].selectedItem++;
          }
          setRows(newRows);
          break;
        default:
          break;
      }
      setRows(newRows);
    };

 const handleSelect = (val, index, id) => {
  const selectedId = id && id.id ? id.id : 0; // Set selectedId to 0 if id is not found
  const selectedItem = val;

  if (!selectedItem) {
    console.log('Selected item not found');
    return;
  }
  const newRows = [...rows];
  // Check if the selected ID already exists in the rows
  const existingRowIndex = newRows.findIndex(row => row.id === selectedItem.id);

  if (existingRowIndex !== -1) {
    newRows[existingRowIndex].qty += 1;
     newRows[existingRowIndex].totqty = newRows[existingRowIndex].pack * newRows[existingRowIndex].qty;
    newRows[existingRowIndex].netamount = (newRows[existingRowIndex].qty * newRows[existingRowIndex].pprice)+((newRows[existingRowIndex].sgst*2));
  } else {
    newRows[index] = {
      id: selectedItem.id,
      hsn: selectedItem.hsn,
      product: selectedItem.product,
      pack: selectedItem.pack,
      disc: selectedItem.disc,
      sgst: selectedItem.sgst,
      cgst: selectedItem.cgst,
      qty: 0,
      totqty: selectedItem.qty * selectedItem.pack,
      unit: selectedItem.unit,
      mrp: selectedItem.mrp,
      pprice: selectedItem.pprice,
      fqty: 0,
      netamount: selectedItem.mrp,

    };
  }
  setRows(newRows);

};


  const handleAmountChange = (e, index) => {
  const newRows = [...rows];
  const { name, value } = e.target;

  newRows[index] = {
    ...newRows[index],
    [name]: parseFloat(value) || 0
  };

  const { pack, qty, pprice, mrp, disc, fqty, sgst, cgst } = newRows[index];

  newRows[index].totqty = pack * qty;
  const net = pprice * qty;
  const disc1 = disc / 100;
  const disca = net * disc1;
  const dism = net - disca;
  const gst = parseFloat(sgst) + parseFloat(cgst);
  const tax1 = (gst / 100) * dism;
  newRows[index].netamount = (dism + tax1);
  newRows[index].gstamount = tax1;
  setRows(newRows);
};




  const handleAddRow = () => {
    const newRows = [...rows];
    newRows.push({id:'', hsn: '', product: '', pack: '', fqty: '', totqty: '', pprice: '', mrp: '', disc: '',
            sgst: '', cgst: ''});
    setRows(newRows);
  };

  const inputRefs = useRef([]);
  useEffect(() => {
      inputRefs.current[inputRefs.current.length - 1]?.focus();
  }, [rows.length]);

  const handleDeleteRow = (index) => {
    const newRows = [...rows];
    newRows.splice(index, 1);
    setRows(newRows);
  };


    useEffect(() => {
    let subtotal = 0;
    let newTotal = 0;
    for (let i = 0; i < rows.length; i++) {
      const row = rows[i];
      subtotal += parseFloat(row.netamount) || 0;
      newTotal = subtotal;
    }
    setSubTotal(subtotal);
  }, [rows]);



const handleChange = (e, index) => {
    const { name, value } = e.target;
    setpharmData(prevState => ({ ...prevState, [name]: value }));
    setRows(prevRows => {
    const newRows = [...prevRows];
    newRows[index] = {
      ...newRows[index],
      [name]: value
    };
    return newRows;
  });
  };


    const formSubmit = (e) => {
      e.preventDefault();
      const dbType = document.getElementById('dbType').value;
        if (!pharmData.supp) {
            Swal.fire('Error', 'Please select a Supplier.', 'error');
            return;
        }
        const tolerance = 1; // Define your tolerance level here

        if (Math.abs(parseFloat(pharmData.invAmount) - parseFloat(subtotal)) > tolerance) {
          Swal.fire('Error', 'Invoice and GRN amount are mismatching.', 'error');
          return;
        }

      const idsFromRows = rows.map(row => row.id || 0);
      const eqtys= rows.map(row => row.totqty);
       const totqtyMap = {};
       const hsnMap = {};
       const qtyMap = {};
        eqtys.forEach((totqty, index) => {
          const id = idsFromRows[index];
          const item = items.find(item => item.id == id);
          const rowTotqty = totqty;
          const itemTotqty = item ? item.totqty : 0;
          const fqty = rows[index].fqty || 0;
          totqtyMap[id] = rowTotqty + itemTotqty + fqty;
          hsnMap[id] = rows[index].hsn || '';
          qtyMap[id] = rows[index].qty || '';
        });
      const allIds = idsFromRows.join(',');

      axios.post(`${baseUrl}get_eqp_grn_no/`)
        .then(response => {
          const grn_id = response.data.value;
          const _formData = new FormData();
          _formData.append('grn_no', grn_id);
          _formData.append('supp', pharmData.supp);
          _formData.append('hsn', rows.map(row => row.hsn).join(','));
          _formData.append('id', rows.map(row => row.id).join(','));
          _formData.append('product', rows.map(row => row.product).join(','));
          _formData.append('pack', rows.map(row => row.pack).join(','));
          _formData.append('qty', rows.map(row => row.qty).join(','));
          _formData.append('fqty', rows.map(row => row.fqty).join(','));
          _formData.append('totqty', rows.map(row => row.totqty).join(','));
          _formData.append('mrp', rows.map(row => row.mrp).join(','));
          _formData.append('pprice', rows.map(row => row.pprice).join(','));
          _formData.append('disc', rows.map(row => row.disc).join(','));
          _formData.append('sgst', rows.map(row => row.sgst).join(','));
          _formData.append('cgst', rows.map(row => row.cgst).join(','));
          _formData.append('netamount', rows.map(row => row.netamount).join(','));
          _formData.append('gstamount', rows.map(row => row.gstamount).join(','));
          _formData.append('grn_date', selectedDate.toISOString().slice(0, 10));
          _formData.append('inv_date', selectedDate1.toISOString().slice(0, 10));
          _formData.append('grnamount', subtotal.toFixed(2));
          _formData.append('invamount', pharmData.invAmount);
          _formData.append('type', dbType);
          _formData.append('invoice', pharmData.invoice);
          _formData.append('status', '1');
          _formData.append('addedby', userName);
          _formData.append('ip_add', ipAddress);
          _formData.append('location', userLocation);

          axios.post(`${baseUrl}add-eqp-grn/`, _formData)
            .then(response => {
              if (response.status === 200 || response.status === 201) {
                allIds.split(',').forEach((id, index) => {
                  const row = rows[index];
                  if (id !== '0') {
                    const phData = {
                        totqty: totqtyMap[id],
                        hsn: hsnMap[id],
                        qty: qtyMap[id],
                        supp: pharmData.supp,
                        ip_add: ipAddress,
                    };
                    axios.put(`${baseUrl}update-eqp-qty/${id}/`, phData)
                      .then(response => {

                    })
                    .catch(error => {
                          console.log(error);
                    });
                 }
                });
                Swal.fire({
                  title: 'GRN Bill Generated.',
                  icon: 'success',
                  timer: 5000,
                  showConfirmButton: false
                });
                setTimeout(() => {
                  window.location.href = '/eqp-grn-entry';
               }, 3000);
              }
            });
            })
            .catch(error => {
              console.log(error);
              Swal.fire(
                'Error!',
                'Failed to generate unique value. Please try again later.',
                'error'
              );
            });
    };

  return (
    <section className="container mt-4">
  <form>
        <div className="row">
        <div className='col-md-6 mb-2'>
            <label>Supplier:</label>
            <select name="supp" id="supp"  onChange={handleConsChange} className="form-control">
                <option> Select Supplier </option>
                {consData.map((category, index) => (
                <option key={index} value={category.id}>
                  {category.name}
                </option>
              ))}
            </select>
        </div>
        <div className='col-md-6 mb-2'>
            <label>GRN Date:</label>
            <DatePicker selected={selectedDate || new Date()} onChange={handleDateChange} dateFormat="yyyy-MM-dd" readOnly/>
        </div>
        </div>
        <div className="row">
        <div className='col-md-6 mb-2'>
              <label>Purchase Type : </label>
              <select name="dbType" id="dbType" className="form-control" value={pharmData.ptype}>
                <option value="CreditPurchase">Credit Purchase</option>
                <option value="CashPurchase">Cash Purchase</option>
              </select>
        </div>
        <div className='col-md-6 mb-2'>
            <label>Invoice Date:</label>
            <DatePicker selected={selectedDate1 || new Date()} onChange={handleDateChange1} dateFormat="yyyy-MM-dd" />
        </div>
        </div>
        <div className="row">
        <div className='col-md-6 mb-2'>
            <label>GRN Amount:</label>
            <input type="number" className="form-control" name="grnAmount" id="grnAmount" placeHolder="Grn Amount"
                value={parseFloat(subtotal).toFixed(2)}/>
        </div>
        <div className='col-md-6 mb-2'>
            <label>Invoice Amount:</label>
            <input type="number" className="form-control" name="invAmount" id="invAmount" onChange={handleChange} placeHolder="Invoice Amount"
                value={pharmData.invAmount}/>
        </div>
        </div>
        <div className="row">
        <div className='col-md-6 mb-2'>
            <label>Invoice Number:</label>
            <input type="text" className="form-control" name="invoice" id="invoice" onChange={handleChange} placeHolder="Invoice No"
                value={pharmData.invoice}/>
        </div>
        </div>
    <div className='table-responsive'>
      <table className="erp-table-modern">
        <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th style={{width: 120}}>HSN</th>
          <th style={{width: 370}}>Equipment</th>
          <th style={{width: 90}} >Pack</th>
          <th style={{width: 120}} >Qty</th>
          <th style={{width: 80}} >F.Qty</th>
          <th style={{width: 90}} >TotQty</th>
          <th style={{width: 120}} >PPrice</th>
          <th style={{width: 120}} >Mrp</th>
          <th style={{width: 110}} >Disc %</th>
          <th style={{width: 110}} >SGST %</th>
          <th style={{width: 110}} >CGST %</th>
          <th style={{width: 120}}>Net Amount<br />(Incl.GST)</th>
           <th style={{width: 80}}>Action</th>

        </tr>
      </thead>
      <tbody>
      {rows.map((row, index) => (
        <tr key={index} className='col-md-12 col-12 mb-2'>
            <td>
            <input
              type="text"
              name="id"
              value={row.id || 0}
              onChange={e => handleChange(e, index)}
              style={{width: 80, display: 'none'}}
              tabIndex={-1}
              readOnly
            />

            <input
              type="text"
              name="hsn"

              value={row.hsn}
              onChange={e => handleChange(e, index)}
              style={{width: 80}}
              tabIndex={-1}
            />
            </td>
            <td>
            <AutoComplete
          items={items}
          options={items}
          sx={{ width: 200 }}
          componentsProps={{
            paper: {
              sx: {
                width: 800
              }
            }
          }}
          fullWidth
          onKeyDown={e => handleKeyDown(e, index)}
          onChange={(event, val, id) => handleSelect(val, index, id)}
          getOptionLabel={(option) => option.product ? option.product : ''}

           renderOption={(props, option) => (
              <Box component="li" {...props}
              fullWidth
              sx={{
              width: 750,
              height: 50,
              borderRadius: 1,
                }}
              >
                {option.product ? `${option.product} ID: ${option.id} MRP: (${option.mrp})
                TQty: ${option.totqty} ` : ''}
              </Box>

            )}
           renderInput={(params) => (
            <div ref={params.InputProps.ref}>
            <input className="form-control" type="text" {...params.inputProps} fullWidth focused autoFocus
               style={{
                  background: "#F7EEFF",
                  }}
             />
            </div>
           )}
            ref={(el) => inputRefs.current[index] = el}

           />
           </td>
           <td>
            <input
              type="number"
              className="ms-2 me-1"
              name="pack"
              style={{width: 60}}
              value={row.pack}
              onChange={(e) => {
                handleChange(e);
                handleAmountChange(e, index);
              }}
              tabIndex={0}
            />
            </td>
            <td>
            <input
              type="number"
              style={{ width: 70 }}
              className="ms-2 me-1"
              value={row.qty}
              name="qty"
              onChange={(e) => {
                handleChange(e, index);
                handleAmountChange(e, index);
              }}
              onKeyDown={(e) => handleKeyDown(e, index)}
              tabIndex={0}
              required
            />
            </td>
            <td>
            <input
              type="number"
              style={{ width: 60 }}
              className="ms-2 me-1"
              value={row.fqty}
              name="fqty"
              onChange={(e) => {
                handleChange(e, index);
                handleAmountChange(e, index);
              }}
              onKeyDown={(e) => handleKeyDown(e, index)}
              tabIndex={0}
              required
            />
            </td>
            <td>
            <input
              type="number"
              className="ms-2 me-1"
              style={{width: 70}}
              name="totqty"
              value={row.totqty}
              onChange={(e) => {
                handleChange(e, index);
                handleAmountChange(e, index);
              }}
              tabIndex={-1}
              readOnly
            />
            </td>
            <td>
            <input
              type="number"
              className="ms-2 me-1"
              style={{width: 70}}
              name="pprice"
              value={row.pprice}
              onChange={(e) => {
                handleChange(e, index);
                handleAmountChange(e, index);
              }}
              onKeyDown={(e) => handleKeyDown(e, index)}
              tabIndex={0}
            />
            </td>
            <td>
            <input
              type="number"
              className="ms-2 me-1"
              style={{width: 70}}
              name="mrp"
              value={row.mrp}
              onChange={(e) => {
                handleChange(e, index);
                handleAmountChange(e, index);
              }}
              onKeyDown={(e) => handleKeyDown(e, index)}
              tabIndex={0}
            />
            </td>
            <td>
            <input
              type="number"
              className="ms-2 me-1"
              style={{width: 50}}
              name="disc"
              value={row.disc}
              onChange={(e) => {
                handleChange(e, index);
                handleAmountChange(e, index);
              }}
              onKeyDown={(e) => handleKeyDown(e, index)}
              tabIndex={0}
            />
            </td>
            <td>
            <input
              type="number"
              className="ms-2 me-1"
              style={{width: 60}}
              name="sgst"
              value={row.sgst}
              onChange={(e) => {
                handleChange(e, index);
                handleAmountChange(e, index);
              }}
              onKeyDown={(e) => handleKeyDown(e, index)}
              tabIndex={0}
            />
            </td>
            <td>
            <input
              type="number"
              className="ms-2 me-1"
              style={{width: 60}}
              name="cgst"
              value={row.cgst}
              onChange={(e) => {
                handleChange(e, index);
                handleAmountChange(e, index);
              }}
              onKeyDown={(e) => handleKeyDown(e, index)}
              tabIndex={0}
            />
            </td>
            <td>
            <input
              type="number"
              className="ms-2 me-1"
              style={{width: 90}}
              name="netamount"
              value={parseFloat(row.netamount).toFixed(2)}
              onChange={(e) => {
                handleChange(e, index);
                handleAmountChange(e, index);
              }}
              onKeyDown={(e) => handleKeyDown(e, index)}
              tabIndex={0}
              readOnly
            />

            <input
              type="text"
              className="ms-2 me-1"
              style={{width: 90, display: 'none'}}
              name="gstamount"
              value={row.gstamount}
              onChange={(e) => {
                handleChange(e, index);
                handleAmountChange(e, index);
              }}
              tabIndex={0}
            />
            </td>
            <td>
             <button className="btn btn-danger" type="button" onClick={() => handleDeleteRow(index)}>Delete</button>
            </td>

        </tr>
      ))}
        </tbody>
        </table>

              <button className="btn btn-success addmore mt-4" type="button" onClick={handleAddRow}>Add More</button>

<div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}
        className='mb-5' >
          <button type="button"  onClick={formSubmit} className="btn btn-primary mt-4">Submit</button>
</div>
    </div>

      </form>
    </section>
  );
};

export default EqpGrnEntry;
